import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'container mx-auto mt-10 flex min-w-0 justify-center pr-0 md:mt-8.5 md:px-4',
    list: 'scrollbar-hidden flex flex-nowrap gap-x-8 overflow-x-auto overflow-y-hidden max-md:px-9 lg:gap-x-13',
    listItem: 'max-w-25 shrink-0',
    link: 'group text-body hover:text-brand-predator flex cursor-pointer flex-col items-center gap-2 text-white',
    image:
      'size-[50px] w-auto max-w-full object-contain brightness-[3] group-hover:brightness-[1]',
    linkText: 'heading-s text-center break-all'
  },
  variants: {
    active: {
      true: {
        link: 'text-brand-predator',
        image: 'brightness-[1]'
      }
    }
  }
});
